<template>
    <div class="section-title">
      <h2 class="main-title text_bold" :class="titleColorClass">{{ mainTitle }}</h2>
      <p class="sub-title text_bold" :class="titleColorClass">{{ subTitle }}</p>
    </div>
  </template>
  
  <script setup>
  import { computed } from 'vue'
  
  const props = defineProps({
    mainTitle: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      required: true
    },
    titleColor: {
      type: String,
      default: 'dark' // 可选值：'dark', 'light', 或其他自定义颜色
    }
  })
  
  const titleColorClass = computed(() => {
    return {
      'text-dark': props.titleColor === 'dark',
      'text-light': props.titleColor === 'light',
      [`text-${props.titleColor}`]: !['dark', 'light'].includes(props.titleColor)
    }
  })
  </script>
  
  <style scoped>
  .section-title {
    width: 100%;
    padding: 80px 20px 20px;
    text-align: center;
  }
  
  .main-title {
    font-size: 34px;
    font-weight: bold;
    margin-bottom: 10px;
    line-height: 1.1em;
    color: #1d1d1f;
  }
  
  .sub-title {
    font-size: 34px;
    font-weight: bold;
    line-height: 1.2;
    max-width: 800px;
    margin: 0 auto;
    color: #1d1d1f;
  }
  
  /* 颜色类 */
  .text-black.main-title,
  .text-black.sub-title {
    color: #1d1d1f;
  }
  
  .text-white.main-title,
  .text-white.sub-title {
    color: #fff;
  }
  
  .text-blue.main-title,
  .text-blue.sub-title {
    color: #0079fc;
  }
  
  .text-orange.main-title,
  .text-orange.sub-title {
    color: #d86c45;
  }
  
  @media screen and (max-width: 768px) {
    .section-title {
      padding: 80px 25px 40px;
      text-align: left;
    }
  
    .main-title {
      font-size: 26px;
    }
  
    .sub-title {
      font-size: 26px;
    }
  }
  </style>